// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
const enum MiniCalendarIcons {
    AlarmClock = 'AlarmClock',
    CalendarAgenda = 'CalendarAgenda',
    CalendarDay = 'CalendarDay',
    ChevronDownMed = 'ChevronDownMed',
    ChevronUpMed = 'ChevronUpMed',
    Error = 'Error',
    Globe = 'Globe',
    List = 'List',
    Lock = 'Lock',
    ResponsesMenu = 'ResponsesMenu',
    ShowTimeAs = 'ShowTimeAs',
    SkypeForBusinessLogo = 'SkypeForBusinessLogo',
    SkypeForBusinessLogo16 = 'SkypeForBusinessLogo16',
    SkypeLogo = 'SkypeLogo',
    SkypeLogo16 = 'SkypeLogo16',
    StatusCircleQuestionMark = 'StatusCircleQuestionMark',
    SyncOccurence = 'SyncOccurence',
    Tag = 'Tag',
    TagSolid = 'TagSolid',
    TeamsLogo = 'TeamsLogo',
    TimePicker = 'TimePicker',
    Unlock = 'Unlock',
    UnsyncOccurence = 'UnsyncOccurence',
    Up = 'Up',
    UserFollowed = 'UserFollowed',
    UserRemove = 'UserRemove',
}

export default MiniCalendarIcons;
